<template>
  <tr-text-field
    ref="field"
    :model-value="maskedValue"
    :label="label"
    :classes="classes"
    :name="name"
    :required="required"
    :pattern="cpfCnpjPattern"
    :custom-validation="validate"
    :error-message="errorMessage"
  >
    <template
      v-if="tooltipInfo"
      #label
    >
      <span>{{ label }}</span>
      <tr-svg-icon
        v-tooltip.top-center="tooltipInfo"
        class="input-label-icon"
        color="blue"
        name="ic-info-outline"
      />
    </template>
  </tr-text-field>
</template>

<script>
import { createMask, validateCpfCnpj } from '@/commons/constants/cpfCnpjMask';
import { normalizeDocument } from '@/commons/formatters/document';
import { regexes } from '@transfeeradev/api-enums';

const DEFAULT_ERROR_MESSAGE = 'Dados incorretos';

export default {
  name: 'cpf-cnpj-field-container',

  props: {
    cpfCnpj: {
      required: false,
      type: String,
      default: ''
    },
    label: {
      required: false,
      type: String,
      default: 'CPF ou CNPJ'
    },
    classes: {
      required: false,
      type: String,
      default: ''
    },
    onChange: {
      required: false,
      type: Function
    },
    name: {
      required: false,
      type: String,
      default: 'cpf_cnpj'
    },
    defaultErrorMessage: {
      required: false,
      type: String,
      default: DEFAULT_ERROR_MESSAGE
    },
    required: {
      required: false,
      type: Boolean,
      default: true
    },
    tooltipInfo: {
      type: String,
      required: false
    }
  },

  emits: ['update:cpfCnpj'],

  data: () => ({
    validationResult: {},
    maskedValue: '',
    cpfCnpjPattern: regexes.CPF_CNPJ
  }),

  computed: {
    errorMessage() {
      return (
        (this.validationResult?.isValid === false ? this.validationResult.errorMessage : null) ||
        this.defaultErrorMessage
      );
    }
  },

  watch: {
    cpfCnpj(val) {
      if (!this._imask) {
        return;
      }
      const raw = normalizeDocument(val);
      if (this._imask.unmaskedValue !== raw) {
        this._imask.unmaskedValue = raw;
        this.maskedValue = this._imask.value;
      }
    }
  },

  mounted() {
    this._imask = createMask(this.$refs.field.getInput());

    this._imask.on('accept', () => {
      this.maskedValue = this._imask.value;
      const raw = normalizeDocument(this._imask.unmaskedValue);
      this.$emit('update:cpfCnpj', raw);
      if (typeof this.onChange === 'function') {
        this.onChange(raw);
      }
    });

    if (this.cpfCnpj) {
      this._imask.unmaskedValue = normalizeDocument(this.cpfCnpj);
      this.maskedValue = this._imask.value;
    }

    this.validate().then(isValid => {
      if (!isValid && this.cpfCnpj) {
        this.$refs.field.forceValidation();
      }
    });
  },

  unmounted() {
    this._imask?.destroy();
    this._imask = null;
  },

  methods: {
    focus() {
      this.$refs.field.focus();
    },

    async validate() {
      const result = await validateCpfCnpj(this.cpfCnpj, {
        checkBlacklist: this.checkBlacklist,
        getBlacklist: this.getBlacklist
      });
      this.validationResult = result;
      return result.isValid;
    }
  }
};
</script>
